import React, { useState } from 'react';

function DateRangeFilter({ onDateRangeChange, initialDays = 14 }) {
  const [selectedOption, setSelectedOption] = useState(initialDays.toString());
  const [customStartDate, setCustomStartDate] = useState('');
  const [customEndDate, setCustomEndDate] = useState('');

  const presetOptions = [
    { value: '7', label: 'Letzte 7 Tage' },
    { value: '14', label: 'Letzte 14 Tage' },
    { value: '30', label: 'Letzte 30 Tage' },
    { value: '60', label: 'Letzte 60 Tage' },
    { value: '90', label: 'Letzte 90 Tage' },
    { value: 'all', label: 'Gesamter Zeitraum' }
  ];

  const handleOptionChange = (e) => {
    const value = e.target.value;
    setSelectedOption(value);
    
    if (value === 'all') {
      // Gesamter Zeitraum - setze startDate auf sehr weit zurück (z.B. 10 Jahre)
      const endDate = new Date();
      const startDate = new Date();
      startDate.setFullYear(startDate.getFullYear() - 10);
      
      onDateRangeChange({
        startDate: startDate.toISOString().split('T')[0],
        endDate: endDate.toISOString().split('T')[0],
        days: null, // null bedeutet "alle"
        isAllTime: true
      });
    } else if (value !== 'custom') {
      const days = parseInt(value);
      const endDate = new Date();
      const startDate = new Date();
      startDate.setDate(startDate.getDate() - days);
      
      onDateRangeChange({
        startDate: startDate.toISOString().split('T')[0],
        endDate: endDate.toISOString().split('T')[0],
        days: days,
        isAllTime: false
      });
    }
  };

  const handleCustomApply = () => {
    if (customStartDate && customEndDate) {
      const start = new Date(customStartDate);
      const end = new Date(customEndDate);
      const diffTime = Math.abs(end - start);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      
      onDateRangeChange({
        startDate: customStartDate,
        endDate: customEndDate,
        days: diffDays,
        isAllTime: false
      });
    }
  };

  return (
    <>
    <style>{`
      @media (max-width: 640px) {
        .date-range-filter { flex-direction: column !important; align-items: stretch !important; }
        .date-range-filter__preset { width: 100%; }
        .date-range-filter__preset select { flex: 1; }
        .date-range-filter__custom { padding-left: 0 !important; border-left: none !important; border-top: 1px solid #e2e8f0; padding-top: 12px !important; margin-top: 4px; flex-wrap: wrap; }
        .date-range-filter__date { flex: 1 1 40% !important; width: auto !important; min-width: 120px; }
        .date-range-filter__apply { flex: 1 1 100% !important; }
      }
    `}</style>
    <div className="date-range-filter" style={{
      background: 'white',
      border: '1px solid #e2e8f0',
      borderRadius: '8px',
      padding: '12px 16px',
      marginBottom: '20px',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
      flexWrap: 'wrap'
    }}>
      {/* Zeitraum Dropdown */}
      <div className="date-range-filter__preset" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4a5568" strokeWidth="2">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
        <label style={{
          fontSize: '13px',
          fontWeight: '500',
          color: '#4a5568',
          whiteSpace: 'nowrap'
        }}>
          Zeitraum:
        </label>
        <select
          value={selectedOption}
          onChange={handleOptionChange}
          style={{
            padding: '6px 10px',
            border: '1px solid #e2e8f0',
            borderRadius: '6px',
            fontSize: '13px',
            color: '#2d3748',
            backgroundColor: 'white',
            cursor: 'pointer',
            minWidth: '150px'
          }}
        >
          {presetOptions.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      {/* Benutzerdefinierter Zeitraum (von – bis) */}
      <div className="date-range-filter__custom" style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        paddingLeft: '16px',
        borderLeft: '1px solid #e2e8f0'
      }}>
        <input
          type="date"
          className="date-range-filter__date"
          aria-label="Von"
          title="Von"
          value={customStartDate}
          max={customEndDate || undefined}
          onChange={(e) => {
            setCustomStartDate(e.target.value);
            setSelectedOption('custom');
          }}
          style={{
            padding: '6px 10px',
            border: '1px solid #e2e8f0',
            borderRadius: '6px',
            fontSize: '13px',
            color: '#2d3748',
            backgroundColor: 'white',
            width: '140px'
          }}
        />
        <span style={{ color: '#718096', fontWeight: '500', fontSize: '13px' }}>bis</span>
        <input
          type="date"
          className="date-range-filter__date"
          aria-label="Bis"
          title="Bis"
          value={customEndDate}
          min={customStartDate || undefined}
          onChange={(e) => {
            setCustomEndDate(e.target.value);
            setSelectedOption('custom');
          }}
          style={{
            padding: '6px 10px',
            border: '1px solid #e2e8f0',
            borderRadius: '6px',
            fontSize: '13px',
            color: '#2d3748',
            backgroundColor: 'white',
            width: '140px'
          }}
        />
        <button
          type="button"
          className="date-range-filter__apply"
          onClick={handleCustomApply}
          disabled={!customStartDate || !customEndDate}
          style={{
            padding: '6px 14px',
            border: 'none',
            borderRadius: '6px',
            background: customStartDate && customEndDate ? '#4a6de5' : '#e2e8f0',
            color: customStartDate && customEndDate ? 'white' : '#a0aec0',
            cursor: customStartDate && customEndDate ? 'pointer' : 'not-allowed',
            fontSize: '13px',
            fontWeight: '500',
            whiteSpace: 'nowrap'
          }}
        >
          OK
        </button>
      </div>
    </div>
    </>
  );
}

export default DateRangeFilter;

